import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";
import LoadingSpinner from "../components/Input/LoadingSpinner";
import HmacSHA256 from "crypto-js/hmac-sha256";
import { Card } from "../components/Card/Card.jsx";
import { Creatable } from 'react-select';
import Select from "react-select";
import "../assets/css/emailClasses.css"
import SweetAlert from "react-bootstrap-sweetalert";
import swal from "sweetalert";



class EmailAccess extends Component {
  state = {
    select: "",
    user: window.UserP.username,
    emailnotification: false,
    email:[]
  };
  onChangeFunc = (name) => (value) => {
    
    this.setState({
      [name]: value,
    });
  };

  componentWillMount(){
    fetch(window.UserP.url + "POD/GetEmailNotification", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
          username: this.state.user,
          IDUser: window.UserP.ClientSubjectID
        }),
      })
        .then((res) => res.json())
        .then((data) => {
            if(data[1]=="True"){
                this.setState({ emailnotification: true});
            }else{
                this.setState({ emailnotification: false});
            }
        
  
        });
        fetch(window.UserP.url + "POD/GetEmailAdress", {
            method: "Post",
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({
              Token: HmacSHA256(
                Math.round(new Date().getTime() / 1000).toString(),
                window.UserP.key
              ).toString(),
              username: this.state.user,
              IDUser: window.UserP.ClientSubjectID
            }),
          })
            .then((res) => res.json())
            .then((data) => {
                let test=[];

                for(let i=0;i<data.length;i++){
                    test.push({label:data[i],value:data[i]})
                }    
                this.setState({ email: test});
            });
        
  }

  hideAlert() {
    
    this.setState({
      alert: null,
    });
  }
  handleChangeCheck2 = (e) => {
    const { checked } = e.target
    
    const getAlert = () => (
        <SweetAlert
          success
          title="Kujdes!"
          closeOnClickOutside={false}
          onConfirm={() => {
            fetch(window.UserP.url + "POD/SetEmailNotification", {
                method: "Post",
                headers: {
                  Accept: "application/json",
                  "Content-type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                },
                body: JSON.stringify({
                  Token: HmacSHA256(
                    Math.round(new Date().getTime() / 1000).toString(),
                    window.UserP.key
                  ).toString(),
                  username: this.state.user,
                  IDUser: window.UserP.ClientSubjectID,
                  NotificationAccess: checked,
                  EmailAdresses: "test@test.com",
                  EmerKlienti: window.UserP.usernameKS,
                }),
              })
                .then((res) => res.json())
                .then((data) => {
                });


            this.setState({
                emailnotification: checked,
                alert: null,
              })}}
          onCancel={() => this.hideAlert()}
          showCancel
        >
          Jeni te sigurt per ndryshimin e njoftimeve?
        </SweetAlert>
      );
   
      this.setState({
        alert: getAlert(),
      });
    
   
  };
  deleteThisGoal2() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Kujdes!"
        closeOnClickOutside={false}
        onConfirm={() =>{
            let email = "";
            for(let i=0;i<this.state.email.length;i++){
                if(i==this.state.email.length-1){
                    email+=this.state.email[i].label;
                }else{
                    email+=this.state.email[i].label+",";
                }
            }
            

            fetch(window.UserP.url + "POD/SetEmailAdress", {
                method: "Post",
                headers: {
                  Accept: "application/json",
                  "Content-type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                },
                body: JSON.stringify({
                  Token: HmacSHA256(
                    Math.round(new Date().getTime() / 1000).toString(),
                    window.UserP.key
                  ).toString(),
                  username: this.state.user,
                  IDUser: window.UserP.ClientSubjectID,
                  NotificationAccess: this.state.emailnotification,
                  EmailAdresses: email,
                  EmerKlienti: window.UserP.usernameKS,
                }),
              })
                .then((res) => res.json())
                .then((data) => {
                });


            this.setState({
                
                alert: null,
              })
            
            
        }
            }
        onCancel={() => this.hideAlert()}
        showCancel
      >
        Jeni te sigurt per rregjistrimin e te dhenave?
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  }
  render() {
    return (

        <div className="content">
            <Grid fluid>
          <Row>
            <Col md={12}>
            {this.state.loading ? (
                        <LoadingSpinner />
                      ) :( 
              <Card
                content={
                   
                  <div >
                    <div className="row">
                    <div className="col-md-1">
                    <label class="switch">
                <input type="checkbox" 
                defaultChecked={this.state.emailnotification}
                checked={this.state.emailnotification}
                onChange={this.handleChangeCheck2}/>
                <span class="slider round"></span>

            </label></div>
            <div className="col-md-5">
                <label className="mt-3">Merrni njoftim automatik me email per perditesimin e statueseve?</label>
            </div>
            </div>
            <label className="m-0">{''}</label>
            <div>{this.state.alert}</div>
            <div className="card card-body bg-light col-md-9">
                    <label className="m-2">Lista e Statuseve:</label>
                    <div className="row">
                    <div className="col-md-1">
                    <label class="checkboxcontainer mt-sm-0 ml-md-2">
                        <input
                            type="checkbox"
                            name="MosDorezim"
                            onChange={this.handleChangeCheck}
                          />
                          <span class="checkmark"></span>
                    </label>
                    </div>
                    <div className="col-md-9">
                        <label className="m-2">Njoftim per Mosdorëzime</label>
                    </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <label className="m-2"></label>
                        <Creatable
                            isMulti
                            className="custom-Select"
                            value={this.state.email}
                            onChange={this.onChangeFunc("email")}
                          />
                        </div>
                        <div className="col-md-4">
                            
                        <button
                            onClick={() => this.deleteThisGoal2()}
                            className="btn btn-danger m-3"
                          >
                            <i className="fa fa-trash" aria-hidden="true" />{" "}
                            <span
                              data-notify="icon"
                              className="pe-7s-diskette"
                            />
                            &nbsp; Ruaj Email
                          </button>
                        </div>
                    </div>
            </div>
        </div>
        
         }
         />
         )}
       </Col>
    
     </Row>
   </Grid>
 </div>
    );
  }
}

export default EmailAccess;
